import { EventEmitter, signal, computed, inject, DestroyRef, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
const iso2ToIso3Countries = {
  AD: 'AND',
  AE: 'ARE',
  AF: 'AFG',
  AG: 'ATG',
  AI: 'AIA',
  AL: 'ALB',
  AM: 'ARM',
  AO: 'AGO',
  AQ: 'ATA',
  AR: 'ARG',
  AS: 'ASM',
  AT: 'AUT',
  AU: 'AUS',
  AW: 'ABW',
  AX: 'ALA',
  AZ: 'AZE',
  BA: 'BIH',
  BB: 'BRB',
  BD: 'BGD',
  BE: 'BEL',
  BF: 'BFA',
  BG: 'BGR',
  BH: 'BHR',
  BI: 'BDI',
  BJ: 'BEN',
  BL: 'BLM',
  BM: 'BMU',
  BN: 'BRN',
  BO: 'BOL',
  BQ: 'BES',
  BR: 'BRA',
  BS: 'BHS',
  BT: 'BTN',
  BV: 'BVT',
  BW: 'BWA',
  BY: 'BLR',
  BZ: 'BLZ',
  CA: 'CAN',
  CC: 'CCK',
  CD: 'COD',
  CF: 'CAF',
  CG: 'COG',
  CH: 'CHE',
  CI: 'CIV',
  CK: 'COK',
  CL: 'CHL',
  CM: 'CMR',
  CN: 'CHN',
  CO: 'COL',
  CR: 'CRI',
  CU: 'CUB',
  CV: 'CPV',
  CW: 'CUW',
  CX: 'CXR',
  CY: 'CYP',
  CZ: 'CZE',
  DE: 'DEU',
  DJ: 'DJI',
  DK: 'DNK',
  DM: 'DMA',
  DO: 'DOM',
  DZ: 'DZA',
  EC: 'ECU',
  EE: 'EST',
  EG: 'EGY',
  EH: 'ESH',
  ER: 'ERI',
  ES: 'ESP',
  ET: 'ETH',
  FI: 'FIN',
  FJ: 'FJI',
  FK: 'FLK',
  FM: 'FSM',
  FO: 'FRO',
  FR: 'FRA',
  GA: 'GAB',
  GB: 'GBR',
  GD: 'GRD',
  GE: 'GEO',
  GF: 'GUF',
  GG: 'GGY',
  GH: 'GHA',
  GI: 'GIB',
  GL: 'GRL',
  GM: 'GMB',
  GN: 'GIN',
  GP: 'GLP',
  GQ: 'GNQ',
  GR: 'GRC',
  GS: 'SGS',
  GT: 'GTM',
  GU: 'GUM',
  GW: 'GNB',
  GY: 'GUY',
  HK: 'HKG',
  HM: 'HMD',
  HN: 'HND',
  HR: 'HRV',
  HT: 'HTI',
  HU: 'HUN',
  ID: 'IDN',
  IE: 'IRL',
  IL: 'ISR',
  IM: 'IMN',
  IN: 'IND',
  IO: 'IOT',
  IQ: 'IRQ',
  IR: 'IRN',
  IS: 'ISL',
  IT: 'ITA',
  JE: 'JEY',
  JM: 'JAM',
  JO: 'JOR',
  JP: 'JPN',
  KE: 'KEN',
  KG: 'KGZ',
  KH: 'KHM',
  KI: 'KIR',
  KM: 'COM',
  KN: 'KNA',
  KP: 'PRK',
  KR: 'KOR',
  KW: 'KWT',
  KY: 'CYM',
  KZ: 'KAZ',
  LA: 'LAO',
  LB: 'LBN',
  LC: 'LCA',
  LI: 'LIE',
  LK: 'LKA',
  LR: 'LBR',
  LS: 'LSO',
  LT: 'LTU',
  LU: 'LUX',
  LV: 'LVA',
  LY: 'LBY',
  MA: 'MAR',
  MC: 'MCO',
  MD: 'MDA',
  ME: 'MNE',
  MF: 'MAF',
  MG: 'MDG',
  MH: 'MHL',
  MK: 'MKD',
  ML: 'MLI',
  MM: 'MMR',
  MN: 'MNG',
  MO: 'MAC',
  MP: 'MNP',
  MQ: 'MTQ',
  MR: 'MRT',
  MS: 'MSR',
  MT: 'MLT',
  MU: 'MUS',
  MV: 'MDV',
  MW: 'MWI',
  MX: 'MEX',
  MY: 'MYS',
  MZ: 'MOZ',
  NA: 'NAM',
  NC: 'NCL',
  NE: 'NER',
  NF: 'NFK',
  NG: 'NGA',
  NI: 'NIC',
  NL: 'NLD',
  NO: 'NOR',
  NP: 'NPL',
  NR: 'NRU',
  NU: 'NIU',
  NZ: 'NZL',
  OM: 'OMN',
  PA: 'PAN',
  PE: 'PER',
  PF: 'PYF',
  PG: 'PNG',
  PH: 'PHL',
  PK: 'PAK',
  PL: 'POL',
  PM: 'SPM',
  PN: 'PCN',
  PR: 'PRI',
  PS: 'PSE',
  PT: 'PRT',
  PW: 'PLW',
  PY: 'PRY',
  QA: 'QAT',
  RE: 'REU',
  RO: 'ROU',
  RS: 'SRB',
  RU: 'RUS',
  RW: 'RWA',
  SA: 'SAU',
  SB: 'SLB',
  SC: 'SYC',
  SD: 'SDN',
  SE: 'SWE',
  SG: 'SGP',
  SH: 'SHN',
  SI: 'SVN',
  SJ: 'SJM',
  SK: 'SVK',
  SL: 'SLE',
  SM: 'SMR',
  SN: 'SEN',
  SO: 'SOM',
  SR: 'SUR',
  SS: 'SSD',
  ST: 'STP',
  SV: 'SLV',
  SX: 'SXM',
  SY: 'SYR',
  SZ: 'SWZ',
  TC: 'TCA',
  TD: 'TCD',
  TF: 'ATF',
  TG: 'TGO',
  TH: 'THA',
  TJ: 'TJK',
  TK: 'TKL',
  TL: 'TLS',
  TM: 'TKM',
  TN: 'TUN',
  TO: 'TON',
  TR: 'TUR',
  TT: 'TTO',
  TV: 'TUV',
  TW: 'TWN',
  TZ: 'TZA',
  UA: 'UKR',
  UG: 'UGA',
  UM: 'UMI',
  US: 'USA',
  UY: 'URY',
  UZ: 'UZB',
  VA: 'VAT',
  VC: 'VCT',
  VE: 'VEN',
  VG: 'VGB',
  VI: 'VIR',
  VN: 'VNM',
  VU: 'VUT',
  WF: 'WLF',
  WS: 'WSM',
  YE: 'YEM',
  YT: 'MYT',
  ZA: 'ZAF',
  ZM: 'ZMB',
  ZW: 'ZWE'
};
/**
 * Returns ISO3 code of provided ISO2 country code
 * @param code
 */
function countryToISO3(code) {
  return iso2ToIso3Countries[code];
}
const PHONE_MASKS = [{
  country: 'AC',
  mask: ' 0000'
}, {
  country: 'AD',
  mask: ' 000 000'
}, {
  country: 'AE',
  mask: '0{15}'
}, {
  country: 'AF',
  mask: ' 00 000 0000'
}, {
  country: 'AG',
  mask: '000 0000'
}, {
  country: 'AI',
  mask: '000 0000'
}, {
  country: 'AL',
  mask: '(000)000 000'
}, {
  country: 'AM',
  mask: ' 00 000 000'
}, {
  country: 'AN',
  mask: '0{15}'
}, {
  country: 'AO',
  mask: '(000)000 000'
}, {
  country: 'AQ',
  mask: ' 00 000'
}, {
  country: 'AR',
  mask: '(000)000 0000'
}, {
  country: 'AS',
  mask: '000 0000'
}, {
  country: 'AT',
  mask: '(000)000 0000'
}, {
  country: 'AU',
  mask: ' 0 0000 0000'
}, {
  country: 'AW',
  mask: ' 000 0000'
}, {
  country: 'AZ',
  mask: ' 00 000 00 00'
}, {
  country: 'BA',
  mask: '0{15}'
}, {
  country: 'BB',
  mask: '000 0000'
}, {
  country: 'BD',
  mask: ' 00 000 000'
}, {
  country: 'BE',
  mask: '(000)000 000'
}, {
  country: 'BF',
  mask: ' 00 00 0000'
}, {
  country: 'BG',
  mask: '(000)000 000'
}, {
  country: 'BH',
  mask: ' 0000 0000'
}, {
  country: 'BI',
  mask: ' 00 00 0000'
}, {
  country: 'BJ',
  mask: ' 00 00 0000'
}, {
  country: 'BM',
  mask: '000 0000'
}, {
  country: 'BN',
  mask: ' 000 0000'
}, {
  country: 'BO',
  mask: ' 0 000 0000'
}, {
  country: 'BR',
  mask: '0{15}'
}, {
  country: 'BS',
  mask: '000 0000'
}, {
  country: 'BT',
  mask: '0{15}'
}, {
  country: 'BW',
  mask: ' 00 000 000'
}, {
  country: 'BY',
  mask: '(00)000 00 00'
}, {
  country: 'BZ',
  mask: ' 000 0000'
}, {
  country: 'CA',
  mask: '(000)000 0000'
}, {
  country: 'CD',
  mask: '(000)000 000'
}, {
  country: 'CF',
  mask: ' 00 00 0000'
}, {
  country: 'CG',
  mask: ' 00 000 0000'
}, {
  country: 'CH',
  mask: ' 00 000 0000'
}, {
  country: 'CI',
  mask: ' 00 000 000'
}, {
  country: 'CK',
  mask: ' 00 000'
}, {
  country: 'CL',
  mask: ' 0 0000 0000'
}, {
  country: 'CM',
  mask: ' 0000 0000'
}, {
  country: 'CN',
  mask: '0{15}'
}, {
  country: 'CO',
  mask: '(000)000 0000'
}, {
  country: 'CR',
  mask: ' 0000 0000'
}, {
  country: 'CU',
  mask: ' 0 000 0000'
}, {
  country: 'CV',
  mask: '(000)00 00'
}, {
  country: 'CW',
  mask: ' 000 0000'
}, {
  country: 'CY',
  mask: ' 00 000 000'
}, {
  country: 'CZ',
  mask: '(000)000 000'
}, {
  country: 'DE',
  mask: ' 00 000000000'
}, {
  country: 'DJ',
  mask: ' 00 00 00 00'
}, {
  country: 'DK',
  mask: ' 00 00 00 00'
}, {
  country: 'DM',
  mask: '000 0000'
}, {
  country: 'DO',
  mask: '0{15}'
}, {
  country: 'DZ',
  mask: ' 00 000 0000'
}, {
  country: 'EC',
  mask: '0{15}'
}, {
  country: 'EE',
  mask: '0{15}'
}, {
  country: 'EG',
  mask: '(000)000 0000'
}, {
  country: 'ER',
  mask: ' 0 000 000'
}, {
  country: 'ES',
  mask: '(000)000 000'
}, {
  country: 'ET',
  mask: ' 00 000 0000'
}, {
  country: 'FI',
  mask: '(000)000 00 00'
}, {
  country: 'FJ',
  mask: ' 00 00000'
}, {
  country: 'FK',
  mask: ' 00000'
}, {
  country: 'FM',
  mask: ' 000 0000'
}, {
  country: 'FO',
  mask: ' 000 000'
}, {
  country: 'FR',
  mask: '0{15}'
}, {
  country: 'GA',
  mask: ' 0 00 00 00'
}, {
  country: 'GD',
  mask: '000 0000'
}, {
  country: 'GE',
  mask: '(000)000 000'
}, {
  country: 'GF',
  mask: ' 00000 0000'
}, {
  country: 'GH',
  mask: '(000)000 000'
}, {
  country: 'GI',
  mask: ' 000 00000'
}, {
  country: 'GL',
  mask: ' 00 00 00'
}, {
  country: 'GM',
  mask: '(000)00 00'
}, {
  country: 'GN',
  mask: ' 00 000 000'
}, {
  country: 'GQ',
  mask: ' 00 000 0000'
}, {
  country: 'GR',
  mask: '(000)000 0000'
}, {
  country: 'GT',
  mask: ' 0 000 0000'
}, {
  country: 'GU',
  mask: '000 0000'
}, {
  country: 'GW',
  mask: ' 0 000000'
}, {
  country: 'GY',
  mask: ' 000 0000'
}, {
  country: 'HK',
  mask: ' 0000 0000'
}, {
  country: 'HN',
  mask: ' 0000 0000'
}, {
  country: 'HR',
  mask: ' 00 000 000'
}, {
  country: 'HT',
  mask: ' 00 00 0000'
}, {
  country: 'HU',
  mask: '(000)000 000'
}, {
  country: 'ID',
  mask: '0{15}'
}, {
  country: 'IE',
  mask: '(000)000 000'
}, {
  country: 'IL',
  mask: '0{15}'
}, {
  country: 'IN',
  mask: '(0000)000 000'
}, {
  country: 'IO',
  mask: ' 000 0000'
}, {
  country: 'IQ',
  mask: '(000)000 0000'
}, {
  country: 'IR',
  mask: '(000)000 0000'
}, {
  country: 'IS',
  mask: ' 000 0000'
}, {
  country: 'IT',
  mask: '(000)0000 000'
}, {
  country: 'JM',
  mask: '000 0000'
}, {
  country: 'JO',
  mask: ' 0 0000 0000'
}, {
  country: 'JP',
  mask: '0{15}'
}, {
  country: 'KE',
  mask: ' 000 000000'
}, {
  country: 'KG',
  mask: '(000)000 000'
}, {
  country: 'KH',
  mask: ' 00 000 000'
}, {
  country: 'KI',
  mask: ' 00 000'
}, {
  country: 'KM',
  mask: ' 00 00000'
}, {
  country: 'KN',
  mask: '000 0000'
}, {
  country: 'KP',
  mask: '0{15}'
}, {
  country: 'KR',
  mask: ' 00 000 0000'
}, {
  country: 'KW',
  mask: ' 0000 0000'
}, {
  country: 'KY',
  mask: '000 0000'
}, {
  country: 'KZ',
  mask: '0{15}'
}, {
  country: 'LA',
  mask: '0{15}'
}, {
  country: 'LB',
  mask: '0{15}'
}, {
  country: 'LC',
  mask: '000 0000'
}, {
  country: 'LI',
  mask: '(000)000 0000'
}, {
  country: 'LK',
  mask: ' 00 000 0000'
}, {
  country: 'LR',
  mask: ' 00 000 000'
}, {
  country: 'LS',
  mask: ' 0 000 0000'
}, {
  country: 'LT',
  mask: '(000)00 000'
}, {
  country: 'LU',
  mask: '(000)000 000'
}, {
  country: 'LV',
  mask: ' 00 000 000'
}, {
  country: 'LY',
  mask: '0{15}'
}, {
  country: 'MA',
  mask: ' 00 0000 000'
}, {
  country: 'MC',
  mask: '0{15}'
}, {
  country: 'MD',
  mask: ' 0000 0000'
}, {
  country: 'ME',
  mask: ' 00 000 000'
}, {
  country: 'MG',
  mask: ' 00 00 00000'
}, {
  country: 'MH',
  mask: ' 000 0000'
}, {
  country: 'MK',
  mask: ' 00 000 000'
}, {
  country: 'ML',
  mask: ' 00 00 0000'
}, {
  country: 'MM',
  mask: '0{15}'
}, {
  country: 'MN',
  mask: ' 00 00 0000'
}, {
  country: 'MO',
  mask: ' 0000 0000'
}, {
  country: 'MP',
  mask: '000 0000'
}, {
  country: 'MQ',
  mask: '(000)00 00 00'
}, {
  country: 'MR',
  mask: ' 00 00 0000'
}, {
  country: 'MS',
  mask: '000 0000'
}, {
  country: 'MT',
  mask: ' 0000 0000'
}, {
  country: 'MU',
  mask: ' 000 0000'
}, {
  country: 'MV',
  mask: ' 000 0000'
}, {
  country: 'MW',
  mask: '0{15}'
}, {
  country: 'MX',
  mask: '0{15}'
}, {
  country: 'MY',
  mask: '0{15}'
}, {
  country: 'MZ',
  mask: ' 00 000 000'
}, {
  country: 'NA',
  mask: ' 00 000 0000'
}, {
  country: 'NC',
  mask: ' 00 0000'
}, {
  country: 'NE',
  mask: ' 00 00 0000'
}, {
  country: 'NF',
  mask: ' 00 000'
}, {
  country: 'NG',
  mask: '0{15}'
}, {
  country: 'NI',
  mask: ' 0000 0000'
}, {
  country: 'NL',
  mask: ' 00 000 0000'
}, {
  country: 'NO',
  mask: '(000)00 000'
}, {
  country: 'NP',
  mask: ' 00 000 000'
}, {
  country: 'NR',
  mask: ' 000 0000'
}, {
  country: 'NU',
  mask: ' 0000'
}, {
  country: 'NZ',
  mask: '0{15}'
}, {
  country: 'OM',
  mask: ' 00 000 000'
}, {
  country: 'PA',
  mask: ' 000 0000'
}, {
  country: 'PE',
  mask: '(000)000 000'
}, {
  country: 'PF',
  mask: ' 00 00 00'
}, {
  country: 'PG',
  mask: '(000)00 000'
}, {
  country: 'PH',
  mask: '(000)000 0000'
}, {
  country: 'PK',
  mask: '(000)000 0000'
}, {
  country: 'PL',
  mask: '(000)000 000'
}, {
  country: 'PS',
  mask: ' 00 000 0000'
}, {
  country: 'PT',
  mask: ' 00 000 0000'
}, {
  country: 'PW',
  mask: ' 000 0000'
}, {
  country: 'PY',
  mask: '(000)000 000'
}, {
  country: 'QA',
  mask: ' 0000 0000'
}, {
  country: 'RE',
  mask: ' 00000 0000'
}, {
  country: 'RO',
  mask: ' 00 000 0000'
}, {
  country: 'RS',
  mask: ' 00 000 0000'
}, {
  country: 'RU',
  mask: '(000)000 00 00'
}, {
  country: 'RW',
  mask: '(000)000 000'
}, {
  country: 'SA',
  mask: '0{15}'
}, {
  country: 'SB',
  mask: '0{15}'
}, {
  country: 'SC',
  mask: ' 0 000 000'
}, {
  country: 'SD',
  mask: ' 00 000 0000'
}, {
  country: 'SE',
  mask: ' 00 000 0000'
}, {
  country: 'SG',
  mask: ' 0000 0000'
}, {
  country: 'SH',
  mask: ' 0000'
}, {
  country: 'SI',
  mask: ' 00 000 000'
}, {
  country: 'SK',
  mask: '(000)000 000'
}, {
  country: 'SL',
  mask: ' 00 000000'
}, {
  country: 'SM',
  mask: ' 0000 000000'
}, {
  country: 'SN',
  mask: ' 00 000 0000'
}, {
  country: 'SO',
  mask: '0{15}'
}, {
  country: 'SR',
  mask: ' 000 0000'
}, {
  country: 'SS',
  mask: ' 00 000 0000'
}, {
  country: 'ST',
  mask: ' 00 00000'
}, {
  country: 'SV',
  mask: ' 00 00 0000'
}, {
  country: 'SX',
  mask: '000 0000'
}, {
  country: 'SY',
  mask: ' 00 0000 000'
}, {
  country: 'SZ',
  mask: ' 00 00 0000'
}, {
  country: 'TC',
  mask: '000 0000'
}, {
  country: 'TD',
  mask: ' 00 00 00 00'
}, {
  country: 'TG',
  mask: ' 00 000 000'
}, {
  country: 'TH',
  mask: '0{15}'
}, {
  country: 'TJ',
  mask: ' 00 000 0000'
}, {
  country: 'TK',
  mask: ' 0000'
}, {
  country: 'TL',
  mask: '0{15}'
}, {
  country: 'TM',
  mask: ' 0 000 0000'
}, {
  country: 'TN',
  mask: ' 00 000 000'
}, {
  country: 'TO',
  mask: ' 00000'
}, {
  country: 'TR',
  mask: '(000)000 0000'
}, {
  country: 'TT',
  mask: '000 0000'
}, {
  country: 'TV',
  mask: '000000000000000'
}, {
  country: 'TW',
  mask: '000000000000000'
}, {
  country: 'TZ',
  mask: ' 00 000 0000'
}, {
  country: 'UA',
  mask: '(00)000 00 00'
}, {
  country: 'UG',
  mask: '(000)000 000'
}, {
  country: 'UK',
  mask: ' 00 0000 0000'
}, {
  country: 'US',
  mask: '(000)000 0000'
}, {
  country: 'UY',
  mask: ' 0 000 00 00'
}, {
  country: 'UZ',
  mask: ' 00 000 0000'
}, {
  country: 'VA',
  mask: '   00000'
}, {
  country: 'VC',
  mask: '000 0000'
}, {
  country: 'VE',
  mask: '(000)000 0000'
}, {
  country: 'VG',
  mask: '000 0000'
}, {
  country: 'VI',
  mask: '000 0000'
}, {
  country: 'VN',
  mask: '0{15}'
}, {
  country: 'VU',
  mask: '0{15}'
}, {
  country: 'WF',
  mask: ' 00 0000'
}, {
  country: 'WS',
  mask: ' 00 0000'
}, {
  country: 'YE',
  mask: '0{15}'
}, {
  country: 'ZA',
  mask: ' 00 000 0000'
}, {
  country: 'ZM',
  mask: ' 00 000 0000'
}, {
  country: 'ZW',
  mask: ' 0 000000'
}];

/**
 * Default limits of items per page
 */
const DEFAULT_LIMIT = 8;
class PaginationManager {
  constructor(limit = DEFAULT_LIMIT) {
    /**
     * List of all items
     */
    this._itemList = [];
    /**
     * Item list for current offset
     */
    this._currentItemList = [];
    /**
     * Current offset
     */
    this._offset = 0;
    /**
     * Offset change event emitter
     */
    this._offsetChange$ = new EventEmitter();
    this._limit = limit;
  }
  /**
   * Returns count of available pages
   */
  get availablePagesCount() {
    return Math.ceil(this._itemList.length / this._limit);
  }
  /**
   * Returns list of active items
   */
  get currentItemList() {
    return this._currentItemList;
  }
  /**
   * Returns offset change emitter
   */
  get offsetChange$() {
    return this._offsetChange$;
  }
  /**
   * Set item list for pagination
   */
  applyItemList(list) {
    this._itemList = list;
    this.setOffset(0);
  }
  /**
   * Set offset
   *
   * @param offset
   */
  setOffset(offset) {
    this._offset = offset;
    this._offsetChange$.next(this._offset);
    this._updateCurrentItemList();
  }
  /**
   * Updates current item list according to current offset
   *
   * @private
   */
  _updateCurrentItemList() {
    this._currentItemList = this._getItemList(this._offset);
  }
  /**
   * Returns item list by provided offset
   *
   * @param offset
   */
  _getItemList(offset) {
    return this._itemList.slice(offset * this._limit, offset * this._limit + this._limit);
  }
}
class CustomValidators {
  /**
   * Uses when two inputs in form group should have identical values (password confirmation for example)
   *
   * @param controlName
   * @param matchingControlName
   * @constructor
   */
  static mustMatch(controlName, matchingControlName) {
    return formGroup => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({
          must_match: true
        });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  /**
   * Uses for override error key that uses native validators
   *
   * Example changeKey('email_pattern', Validators.pattern(<email validation regexp>))
   *  result: {email_pattern: true}
   *
   * If you will just use Validators.pattern(<email validation regexp>)
   *  result should be: {pattern: true}
   *
   * @param newKey
   * @param validator
   */
  static changeKey(newKey, validator) {
    return control => {
      const invalid = validator(control);
      if (invalid) {
        const validationResult = invalid[Object.keys(invalid)[0]];
        return {
          [newKey]: validationResult
        };
      } else {
        return null;
      }
    };
  }
  /**
   * Is user eighteen or more years old
   *
   * @param control
   */
  // @ts-ignore
  static eighteenYearsOld(control) {
    if (control.value) {
      let [yy, mm, dd] = control.value.split(/[\/\-]/);
      dd = Number(dd || 0);
      mm = Number(mm || 0);
      yy = Number(yy || 0);
      const invalid = new Date(yy + 18, mm - 1, dd) > new Date();
      if (invalid) {
        return {
          eighteen_years: invalid
        };
      } else {
        return null;
      }
    }
  }
  // @ts-ignore
  static validDate(control) {
    if (control.value) {
      const days = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      const [yy, mm, dd] = control.value.split(/[\/\-]/).map(val => Number(val || 0));
      const invalid = mm && dd && dd > days[mm - 1];
      if (invalid) {
        return {
          pattern: invalid
        };
      } else {
        return null;
      }
    }
  }
}

/**
 * Available Birthday years
 */
const BirthdayYearList = numberArray(1918, new Date().getFullYear() - 18);
/**
 * List of month numbers
 */
const MonthList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
/**
 * List of days of month
 */
const MonthDayList = numberArray(1, 31);
/**
 * Returns array of numbers from provided range
 *
 * @param start
 * @param stop
 */
function numberArray(start, stop) {
  return Array(stop - start + 1).fill(0).map((_, idx) => start + idx);
}

/**
 * Uses for uniqueization items from some lists
 * You need to create instance of this class for each group of lists
 */
class Uniqueizer {
  constructor() {
    /**
     * Items that already added in list and can not be unique
     */
    this._checkedItems = [];
  }
  /**
   * Returns list of objects from provided list that not be used before
   * Uniqueization performs by provided param name
   *
   * @param list
   * @param param
   * @param count
   */
  uniqueizeObjects(list, param, count = 12) {
    let i = 0;
    this._checkedItems = [];
    return list.filter(item => {
      if (!this._checkedItems.includes(item[param])) {
        if (!count || i < count) {
          this._checkedItems.push(item[param]);
          i++;
          return true;
        }
      }
      return false;
    });
  }
}
const botList = ['PetalBot', 'Googlebot', 'Chrome-Lighthouse', 'SemrushBot', 'AhrefsBot', 'bingbot', 'Yahoo', 'Yandex'];
function isBot(userAgent = '') {
  return Boolean(botList.filter(e => userAgent.includes(e)).length);
}
function rangeArray(start, end) {
  return [...Array(end - start + 1).keys()].map(x => x + start);
}
const isObject = value => {
  return !!(value && typeof value === 'object' && !Array.isArray(value));
};
const isArray = value => {
  return !!(value && Array.isArray(value));
};
const isString = value => {
  return !!(value && typeof value === 'string');
};
const isNumber = value => {
  return !!(value && typeof value === 'number');
};
const isBoolean = value => {
  return !!(value && typeof value === 'boolean');
};
function isNullOrUndefined(value) {
  return value === null || value === undefined;
}
function isDefined(val) {
  return val !== null && val !== undefined;
}
const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0,
      v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
const randNum = () => {
  return Math.floor(Math.random() * 1000) + Date.now();
};
function fromEntries(iterable) {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;
    return obj;
  }, {});
}
function toList(x) {
  switch (true) {
    case x instanceof Array:
      return x;
    case typeof x === 'undefined':
      return [];
    default:
      return [x];
  }
}
function defaults(...args) {
  return args.reverse().reduce((acc, obj) => ({
    ...acc,
    ...obj
  }), {});
}
function originalOrder(a, b) {
  return 0;
}
const isObjectEmpty = objectName => {
  return Object.keys(objectName).length === 0;
};
const isEqualObjects = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};
/**
 * Convert object to query string params for url
 * @param obj
 * @private
 */
function objToQueryString(obj) {
  const keyValuePairs = Object.entries(obj).map(([key, value]) => {
    if (isArray(value)) {
      value = value.join(',');
    }
    return `${key}=${encodeURIComponent(value)}`;
  });
  return keyValuePairs.join('&');
}
function decodeHexStr(str) {
  const da = str.match(/[\da-f]{2}/gi);
  if (da) {
    const byteArray = new Uint8Array(da.map(h => parseInt(h, 16)));
    const decodedString = new TextDecoder().decode(byteArray);
    return JSON.parse(decodedString);
  } else {
    return null;
  }
}
function isHexString(str) {
  return /^[0-9a-fA-F]+$/i.test(str);
}
function removeDuplicatesInObjects(array, property) {
  const uniqueIds = [];
  const unique = array.filter(element => {
    const isDuplicate = uniqueIds.includes(element[property]);
    if (!isDuplicate) {
      uniqueIds.push(element[property]);
      return true;
    }
    return false;
  });
  return unique;
}
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function decoder(arr, indices) {
  return indices.reduce(function (previousValue, currentValue) {
    return previousValue + arr[currentValue];
  }, '');
}
function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
function matchFirstToSecondArrayLength(arr1, arr2) {
  if (!arr1?.length || !arr2?.length) {
    return arr1;
  }
  const arr1Length = arr1.length;
  const arr2Length = arr2.length;
  if (arr1Length < arr2Length) {
    const repeatTimes = Math.ceil(arr2Length / arr1Length);
    let extendedFsNumbers = [];
    for (let i = 0; i < repeatTimes; i++) {
      extendedFsNumbers = extendedFsNumbers.concat(arr1);
    }
    arr1 = extendedFsNumbers.slice(0, arr2Length);
  }
  return arr1;
}
function reverseRecord(input) {
  return Object.fromEntries(Object.entries(input).map(([key, value]) => [value, key]));
}
function areDeepObjectsEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true;
  }
  if (obj1 == null || obj2 == null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return false;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    if (!keys2.includes(key)) {
      return false;
    }
    if (!areDeepObjectsEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
}
function dateInputValueMapper(input) {
  let value = input.value.replace(/[^0-9]/g, '');
  if (value.length > 2) {
    value = value.slice(0, 2) + '/' + value.slice(2);
  }
  if (value.length > 5) {
    value = value.slice(0, 5) + '/' + value.slice(5);
  }
  if (value.length > 10) {
    value = value.slice(0, 10);
  }
  return value;
}
function encodeToHex(jsonString) {
  let result = '';
  for (let i = 0; i < jsonString.length; i++) {
    result += jsonString.charCodeAt(i).toString(16);
  }
  return result;
}
function encodeToBase64(jsonString) {
  return btoa(unescape(encodeURIComponent(jsonString)));
}
function decodeFromBase64(jsonString) {
  return decodeURIComponent(escape(atob(jsonString)));
}
function convertDobFormat(date) {
  if (date) {
    const parts = date.split('/');
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    return `${year}-${month}-${day}`;
  }
}
const CORRECTED_PHONE_NUMBERS = {
  "AC": "+247 40123",
  "AD": "+376 312 345",
  "AE": "+971 50 123 4567",
  "AF": "+93 70 123 4567",
  "AG": "+1 268 464 1234",
  "AI": "+1 264 235 1234",
  "AL": "+355 672 123 456",
  "AM": "+374 77 123 456",
  "AO": "+244 923 123 456",
  "AR": "+54 9 11 2345 6789",
  "AS": "+1 684 733 1234",
  "AT": "+43 664 123 456",
  "AU": "+61 412 345 678",
  "AW": "+297 560 1234",
  "AX": "+358 412 345 678",
  "AZ": "+994 40 123 4567",
  "BA": "+387 61 123 456",
  "BB": "+1 246 250 1234",
  "BD": "+880 181 234 5678",
  "BE": "+32 470 123 456",
  "BF": "+226 70 123 456",
  "BG": "+359 430 123 45",
  "BH": "+973 3600 1234",
  "BI": "+257 7956 1234",
  "BJ": "+229 0195 1234 56",
  "BL": "+590 690 001 234",
  "BM": "+1 441 370 1234",
  "BN": "+673 712 3456",
  "BO": "+591 712 34567",
  "BQ": "+599 318 1234",
  "BR": "+55 11 96123 4567",
  "BS": "+1 242 359 1234",
  "BT": "+975 17 123 456",
  "BW": "+267 71 123 456",
  "BY": "+375 29 491 1911",
  "BZ": "+501 622 1234",
  "CA": "+1 506 234 5678",
  "CC": "+61 412 345 678",
  "CD": "+243 99 123 4567",
  "CF": "+236 700 123 45",
  "CG": "+242 06 123 456",
  "CH": "+41 78 123 4567",
  "CI": "+225 01 234 5678 9",
  "CK": "+682 71 234",
  "CL": "+56 22 123 4567",
  "CM": "+237 67 123 4567",
  "CN": "+86 131 2345 6789",
  "CO": "+57 321 123 4567",
  "CR": "+506 8312 3456",
  "CU": "+53 51 234 567",
  "CV": "+238 991 1234",
  "CW": "+599 951 81234",
  "CX": "+61 412 345 678",
  "CY": "+357 96 123 456",
  "CZ": "+420 601 123 456",
  "DE": "+49 151 2345 6789",
  "DJ": "+253 77 831 001",
  "DK": "+45 344 12345",
  "DM": "+1 767 225 1234",
  "DO": "+1 809 234 5678",
  "DZ": "+213 55 123 4567",
  "EC": "+593 99 123 4567",
  "EE": "+372 51 234 567",
  "EG": "+20 100 123 4567",
  "EH": "+212 650 123 456",
  "ER": "+291 7 123 456",
  "ES": "+34 612 345 678",
  "ET": "+251 91 123 4567",
  "FI": "+358 41 234 5678",
  "FJ": "+679 70 12345",
  "FK": "+500 51234",
  "FM": "+691 350 1234",
  "FO": "+298 211 234",
  "FR": "+33 6 12 34 56 78",
  "GA": "+241 06 031 234",
  "GB": "+44 7400 123456",
  "GD": "+1 473 403 1234",
  "GE": "+995 555 123 456",
  "GF": "+594 694 201 234",
  "GG": "+44 7781 123456",
  "GH": "+233 23 123 4567",
  "GI": "+350 57 123456",
  "GL": "+299 22 1234",
  "GM": "+220 301 2345",
  "GN": "+224 601 123 456",
  "GP": "+590 690 001 234",
  "GQ": "+240 222 123 456",
  "GR": "+30 691 234 5678",
  "GT": "+502 51 234 567",
  "GU": "+1 671 300 1234",
  "GW": "+245 955 012 345",
  "GY": "+592 609 1234",
  "HK": "+852 5123 4567",
  "HN": "+504 9123 4567",
  "HR": "+385 92 123 4567",
  "HT": "+509 3410 1234",
  "HU": "+36 20 123 4567",
  "ID": "+62 812 3456 78",
  "IE": "+353 850 123 456",
  "IL": "+972 50 234 5678",
  "IM": "+44 7924 123456",
  "IN": "+91 812 345 6789",
  "IO": "+246 380 1234",
  "IQ": "+964 791 234 5678",
  "IR": "+98 912 345 6789",
  "IS": "+354 611 1234",
  "IT": "+39 312 345 6789",
  "JE": "+44 7797 123456",
  "JM": "+1 876 210 1234",
  "JO": "+962 79 012 3456",
  "JP": "+81 90 1234 5678",
  "KE": "+254 712 123 456",
  "KG": "+996 700 123 456",
  "KH": "+855 91 234 567",
  "KI": "+686 7200 1234",
  "KM": "+269 32 123 45",
  "KN": "+1 869 765 2917",
  "KP": "+850 191 234 5678",
  "KR": "+82 10 2000 0000",
  "KW": "+965 500 12345",
  "KY": "+1 345 323 1234",
  "KZ": "+7 771 000 9998",
  "LA": "+856 20 23 123 456",
  "LB": "+961 71 123 456",
  "LC": "+1 758 284 5678",
  "LI": "+423 660 234 567",
  "LK": "+94 71 234 5678",
  "LR": "+231 770 123 456",
  "LS": "+266 50 123 456",
  "LT": "+370 612 34567",
  "LU": "+352 628 123 456",
  "LV": "+371 21 234 567",
  "LY": "+218 91 234 5678",
  "MA": "+212 650 123 456",
  "MC": "+377 6 12 34 56 78",
  "MD": "+373 621 12345",
  "ME": "+382 67 622 901",
  "MF": "+590 690 001 234",
  "MG": "+261 32 123 4567",
  "MH": "+692 235 1234",
  "MK": "+389 72 345 678",
  "ML": "+223 65 012 345",
  "MM": "+95 92 123 456",
  "MN": "+976 88 123 456",
  "MO": "+853 66 123 456",
  "MP": "+1 670 234 5678",
  "MQ": "+596 696 201 234",
  "MR": "+222 22 123 456",
  "MS": "+1 664 492 3456",
  "MT": "+356 9696 1234",
  "MU": "+230 525 12345",
  "MV": "+960 77 12345",
  "MW": "+265 99 123 4567",
  "MX": "+52 222 123 4567",
  "MY": "+60 12 345 6789",
  "MZ": "+258 82 123 4567",
  "NA": "+264 81 123 4567",
  "NC": "+687 75 1234",
  "NE": "+227 93 123 456",
  "NF": "+672 3 81234",
  "NG": "+234 802 123 4567",
  "NI": "+505 8123 4567",
  "NL": "+31 6 123 45678",
  "NO": "+47 406 12345",
  "NP": "+977 984 123 4567",
  "NR": "+674 555 1234",
  "NU": "+683 888 4012",
  "NZ": "+64 21 123 45675",
  "OM": "+968 9212 3456",
  "PA": "+507 6123 4567",
  "PE": "+51 912 345 678",
  "PF": "+689 87 123 456",
  "PG": "+675 701 23456",
  "PH": "+63 905 123 4567",
  "PK": "+92 301 234 5678",
  "PL": "+48 512 345 678",
  "PM": "+508 55 1234",
  "PR": "+1 787 234 5678",
  "PS": "+970 599 123 456",
  "PT": "+351 912 345 678",
  "PW": "+680 620 1234",
  "PY": "+595 961 456 789",
  "QA": "+974 33 123 456",
  "RE": "+262 692 123 456",
  "RO": "+40 712 034 567",
  "RS": "+381 60 123 4567",
  "RU": "+7 912 345 6789",
  "RW": "+250 720 123 456",
  "SA": "+966 51 234 5678",
  "SB": "+677 742 1234",
  "SC": "+248 251 0123",
  "SD": "+249 91 123 1234",
  "SE": "+46 70 123 4567",
  "SG": "+65 8123 4567",
  "SH": "+290 51234",
  "SI": "+386 31 234 567",
  "SJ": "+47 412 34567",
  "SK": "+421 912 123 456",
  "SL": "+232 25 123 456",
  "SM": "+378 6666 1212",
  "SN": "+221 70 123 4567",
  "SO": "+252 711 23456",
  "SR": "+597 74 12345",
  "SS": "+211 977 123 456",
  "ST": "+239 981 2345",
  "SV": "+503 7012 3456",
  "SX": "+1 721 520 5678",
  "SY": "+963 944 567 890",
  "SZ": "+268 7612 3456",
  "TA": "+290 8999",
  "TC": "+1 649 231 1234",
  "TD": "+235 63 012 345",
  "TG": "+228 90 123 456",
  "TH": "+66 81 234 5678",
  "TJ": "+992 917 123 456",
  "TK": "+690 7290",
  "TL": "+670 772 12345",
  "TM": "+993 66 123 456",
  "TN": "+216 20 123 456",
  "TO": "+676 771 5123",
  "TR": "+90 501 234 5678",
  "TT": "+1 868 291 1234",
  "TV": "+688 901 234",
  "TW": "+886 912 345 678",
  "TZ": "+255 621 234 567",
  "UA": "+380 50 123 4567",
  "UG": "+256 712 345 678",
  "US": "+1 201 555 0123",
  "UY": "+598 94 231 234",
  "UZ": "+998 91 234 5678",
  "VA": "+39 06 698 12345",
  "VC": "+1 784 430 1234",
  "VE": "+58 412 123 4567",
  "VG": "+1 284 300 1234",
  "VI": "+1 340 642 1234",
  "VN": "+84 91 234 5678",
  "VU": "+678 591 2345",
  "WF": "+681 82 1234",
  "WS": "+685 721 2345",
  "XK": "+383 43 201 234",
  "YE": "+967 71 234 5678",
  "YT": "+262 639 012 345",
  "ZA": "+27 71 123 4567",
  "ZM": "+260 955 123 456",
  "ZW": "+263 71 234 5678"
};

/**
 * Resolves a chain of redirect results, returning a Promise that resolves to `true` if any of the redirect results are truthy, or `false` otherwise.
 *
 * @param {...(Function|Promise|any)} redirectResults - An array of redirect results, which can be functions, Promises, or any other value.
 * @returns {Promise<boolean>} A Promise that resolves to `true` if any of the redirect results are truthy, or `false` otherwise.
 */
function resolveChain(...redirectResults) {
  return redirectResults.reduce((prev, curr) => {
    return prev.then(result => {
      if (result) return true;
      let next = curr instanceof Function ? curr() : curr;
      if (next && typeof next?.subscribe === 'function') {
        return new Promise(resolve => next.subscribe(resolve));
      }
      return next instanceof Promise ? next : Promise.resolve(next);
    });
  }, Promise.resolve(false));
}

/**
 * Converts an Observable into a Signal with a provided initial value.
 * This is a shorthand helper to reduce boilerplate when working with toSignal.
 *
 * @param source$ - The source Observable to convert
 * @param initial - The initial value for the Signal before the Observable emits
 * @returns A Signal<T> that reflects the latest value from the Observable
 */
function toSafeSignal(source$, initial) {
  return toSignal(source$, {
    initialValue: initial
  });
}
function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
function sequence(...steps) {
  return async () => {
    for (const step of steps) {
      await step();
    }
  };
}
function delayStep(ms) {
  return () => new Promise(resolve => setTimeout(resolve, ms));
}
function parallel(...steps) {
  return () => Promise.all(steps.map(fn => Promise.resolve().then(fn))).then(() => {});
}
class AnimationManager {
  constructor() {
    this.currentStep = signal(-1, ...(ngDevMode ? [{
      debugName: "currentStep"
    }] : []));
    this.currentClass = signal(null, ...(ngDevMode ? [{
      debugName: "currentClass"
    }] : []));
    this.isRunning = signal(false, ...(ngDevMode ? [{
      debugName: "isRunning"
    }] : []));
    this.isPaused = signal(false, ...(ngDevMode ? [{
      debugName: "isPaused"
    }] : []));
    this.isCancelled = signal(false, ...(ngDevMode ? [{
      debugName: "isCancelled"
    }] : []));
    this.isFinished = computed(() => !this.isRunning() && !this.isPaused() && !this.isCancelled(), ...(ngDevMode ? [{
      debugName: "isFinished"
    }] : []));
    this._steps = [];
    this._currentPauseResolver = null;
    this._events = {};
    this._loopForever = false;
    this._repeatCount = null;
    this._reversed = false;
  }
  addStep(delayInput, action) {
    const step = typeof delayInput === 'number' ? {
      delay: delayInput,
      action
    } : {
      delay: delayInput.delay,
      action,
      className: delayInput.className
    };
    this._steps.push(step);
    return this;
  }
  on(events) {
    this._events = {
      ...this._events,
      ...events
    };
    return this;
  }
  cancel() {
    this.isCancelled.set(true);
    this.isRunning.set(false);
    this.isPaused.set(false);
    this._events.onCancel?.();
    this.resume();
  }
  pause() {
    if (this.isRunning()) {
      this.isPaused.set(true);
      this._events.onPaused?.();
    }
  }
  resume() {
    if (this.isPaused()) {
      this.isPaused.set(false);
      this._events.onResumed?.();
      this._currentPauseResolver?.();
      this._currentPauseResolver = null;
    }
  }
  loop() {
    this._loopForever = true;
    return this;
  }
  repeat(n) {
    this._repeatCount = n;
    return this;
  }
  reverse() {
    this._reversed = true;
    return this;
  }
  reset() {
    this._steps = [];
    this._events = {};
    this._loopForever = false;
    this._repeatCount = null;
    this._reversed = false;
    this.currentStep.set(-1);
    this.currentClass.set(null);
    this.isRunning.set(false);
    this.isPaused.set(false);
    this.isCancelled.set(false);
    this._events.onReset?.();
    return this;
  }
  async _checkPause() {
    while (this.isPaused() && !this.isCancelled()) {
      await new Promise(resolve => this._currentPauseResolver = resolve);
    }
  }
  async _runStepsOnce() {
    const steps = this._reversed ? [...this._steps].reverse() : this._steps;
    for (let i = 0; i < steps.length; i++) {
      if (this.isCancelled()) return;
      this.currentStep.set(i);
      this.currentClass.set(steps[i].className ?? null);
      await this._checkPause();
      const step = steps[i];
      await delay(step.delay);
      await this._checkPause();
      if (this.isCancelled()) return;
      this._events.onStep?.(i);
      await step.action();
    }
  }
  async run() {
    this.isCancelled.set(false);
    this.isPaused.set(false);
    this.isRunning.set(true);
    this.currentStep.set(-1);
    this.currentClass.set(null);
    this._events.onStart?.();
    if (this._loopForever) {
      while (!this.isCancelled()) {
        await this._runStepsOnce();
      }
    } else if (this._repeatCount !== null) {
      for (let i = 0; i < this._repeatCount; i++) {
        if (this.isCancelled()) break;
        await this._runStepsOnce();
      }
    } else {
      await this._runStepsOnce();
    }
    this.isRunning.set(false);
    if (!this.isCancelled()) {
      this._events.onComplete?.();
    }
  }
}

/**
 * Converts an Observable to a Signal-based Resource with value, error, and loading states.
 *
 * @template T The type of value emitted by the source Observable
 * @param source$ The source Observable to convert into a Signal resource
 * @returns A Resource object with reactive signals for value, error, and loading status
 *
 * @remarks
 * This function creates a reactive resource that tracks the state of an Observable,
 * providing signals for accessing the latest value, any errors, and loading status.
 *
 * @example
 *   ts
 *   const resource = toSignalResource(myObservable$);
 *
 *   html
 *   if(resource.value()) {
 *     <div>{{resource.value()}}</div>
 *   }
*    if(resource.loading()) {
 *     Loading...
 *   }
 *   if(resource.error()) {
 *     {{resource.error()}}
 *   }
 *
 */
function toSignalResource(source$) {
  const destroyRef = inject(DestroyRef);
  const triggered = signal(false, ...(ngDevMode ? [{
    debugName: "triggered"
  }] : []));
  const state = signal({
    loading: false
  }, ...(ngDevMode ? [{
    debugName: "state"
  }] : []));
  let subscription = null;
  effect(() => {
    if (!triggered()) return;
    state.update(s => ({
      ...s,
      loading: true
    }));
    subscription = source$.subscribe({
      next: val => state.update(s => ({
        ...s,
        value: val,
        error: undefined,
        loading: false
      })),
      error: err => state.update(s => ({
        ...s,
        error: err,
        loading: false
      }))
    });
    destroyRef.onDestroy(() => subscription?.unsubscribe());
  });
  const wrap = getter => {
    return computed(() => {
      if (!triggered()) {
        queueMicrotask(() => triggered.set(true));
      }
      return getter();
    });
  };
  return {
    value: wrap(() => state().value),
    error: wrap(() => state().error),
    loading: wrap(() => state().loading)
  };
}

/**
 * The function `getDayNamesKeys` returns an array of lowercase day names keys for the days of the week
 * in 2023.
 * @returns An array of strings containing the keys for the day names in the format "t.dayName"
 * converted to lowercase.
 */
function getDayNamesKeys() {
  const dayNames = [];
  for (let i = 0; i < 7; i++) {
    const dt = new Date(Date.UTC(2023, 0, 1 + i));
    const dayName = dt.toLocaleDateString('en-US', {
      weekday: 'long',
      timeZone: 'UTC'
    });
    dayNames.push(`t.${dayName}`.toLowerCase());
  }
  return dayNames;
}

/**
 * Generated bundle index. Do not edit.
 */

export { AnimationManager, BirthdayYearList, CORRECTED_PHONE_NUMBERS, CustomValidators, MonthDayList, MonthList, PHONE_MASKS, PaginationManager, Uniqueizer, areDeepObjectsEqual, botList, capitalizeFirstLetter, convertDobFormat, countryToISO3, dateInputValueMapper, decodeFromBase64, decodeHexStr, decoder, defaults, delay, delayStep, encodeToBase64, encodeToHex, fromEntries, getDayNamesKeys, getRandomNumber, isArray, isBoolean, isBot, isDefined, isEqualObjects, isHexString, isNullOrUndefined, isNumber, isObject, isObjectEmpty, isString, iso2ToIso3Countries, matchFirstToSecondArrayLength, numberArray, objToQueryString, originalOrder, parallel, randNum, rangeArray, removeDuplicatesInObjects, resolveChain, reverseRecord, sequence, toList, toSafeSignal, toSignalResource, uuidv4 };
